import { MetaFunction } from '@remix-run/node'
import { ReactElement } from 'react'

export const meta: MetaFunction = () => [
  { title: `Link Not Available` },
  { description: `The online scheduler you are looking for is no longer available at this link.` },
]

export default function SchedulingUnavailable(): ReactElement {
  return (
    <div className="trackable-background mt-0 flex h-screen flex-col items-center justify-center space-y-4 px-12 md:justify-normal md:p-0 md:pt-96">
      <p className="text-center text-heading-xl font-semibold text-trn-900">
        This link is no longer <br className="hidden md:flex" />
        available
      </p>
      <p className="whitespace-pre-line text-center text-body-md text-neutral-700">
        It seems like the online scheduler you are looking for is no <br className="hidden md:block" />
        longer at this link.
      </p>
    </div>
  )
}
